class StkGirisSearchDTO {
  baslangicTarih?: Date;
  bitisTarih?: Date;
  muracaatId?: number = null;
  faturaNo: string = "";
  irsaliyeNo: string = "";
  faturaBasTarih?: Date;
  faturaBitTarih?: Date;
  irsaliyeBasTarih?: Date;
  irsaliyeBitTarih?: Date;
  servisId?: number = null;
  kurumId?: number = null;
  islemTipId?: number = null;
  depoDonemId?: number = null;
  depoTanimId?: number = null;
  gonderenOrganizasyonId?: number = null;

  firmaId?: number = null;
  diskurumId?: number = null;
}

export default StkGirisSearchDTO;
